import React, { useState, useEffect } from 'react';
import { getQuotes, updateQuoteStatus, deleteQuote } from '../api';

const QuotesAdmin = () => {
  const [items, setItems]     = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  const load = async () => {
    setLoading(true);
    const res = await getQuotes();
    if (res.success) setItems(res.data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const handleStatus = async (id, status) => {
    await updateQuoteStatus(id, status);
    await load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this quote request?')) return;
    await deleteQuote(id);
    setSelected(null);
    await load();
  };

  const fmt = (d) => new Date(d).toLocaleString('en-IN', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' });

  return (
    <div>
      <div className="admin-section-header">
        <h2>Quote Requests</h2>
      </div>

      <div style={{ display:'grid', gridTemplateColumns: selected ? '1fr 1fr' : '1fr', gap:20 }}>
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr><th>Name</th><th>Email</th><th>Service</th><th>Budget</th><th>Date</th><th>Status</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {items.map(q => (
                <tr key={q.id} style={{ cursor:'pointer', background: selected?.id===q.id ? '#f0f4ff' : '' }}
                  onClick={() => setSelected(q)}>
                  <td style={{ fontWeight:600 }}>{q.name}</td>
                  <td style={{ fontSize:'0.82rem', color:'#6c757d' }}>{q.email}</td>
                  <td style={{ fontSize:'0.82rem' }}>{q.service}</td>
                  <td style={{ fontSize:'0.78rem', color:'#ff6b35', fontWeight:600 }}>₹{q.budget || '—'}</td>
                  <td style={{ fontSize:'0.78rem', color:'#adb5bd', whiteSpace:'nowrap' }}>{fmt(q.created_at)}</td>
                  <td>
                    <select value={q.status} onClick={e => e.stopPropagation()}
                      onChange={e => handleStatus(q.id, e.target.value)}
                      style={{ padding:'4px 8px', border:'1.5px solid #dee2e6', borderRadius:6, fontSize:'0.78rem', cursor:'pointer' }}>
                      <option value="pending">Pending</option>
                      <option value="reviewed">Reviewed</option>
                      <option value="quoted">Quoted</option>
                      <option value="accepted">Accepted</option>
                      <option value="rejected">Rejected</option>
                    </select>
                  </td>
                  <td onClick={e => e.stopPropagation()}>
                    <button className="btn-admin-primary btn-admin-sm btn-admin-danger" onClick={() => handleDelete(q.id)}>🗑</button>
                  </td>
                </tr>
              ))}
              {!items.length && <tr><td colSpan={7} style={{ textAlign:'center', color:'#adb5bd', padding:'40px' }}>No quote requests yet.</td></tr>}
            </tbody>
          </table>
        </div>

        {selected && (
          <div style={{ background:'white', borderRadius:14, padding:24, boxShadow:'0 2px 12px rgba(0,0,0,0.06)', border:'1px solid #f0f0f0' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:20 }}>
              <h3 style={{ fontWeight:700, color:'#1a1a5e', fontSize:'1rem' }}>Quote Detail</h3>
              <button onClick={() => setSelected(null)} style={{ background:'#f8f9fa', border:'1px solid #e9ecef', borderRadius:8, padding:'4px 10px', cursor:'pointer', fontSize:'0.8rem' }}>✕ Close</button>
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
              {[
                ['Name',    selected.name],
                ['Email',   selected.email],
                ['Phone',   selected.phone||'—'],
                ['Service', selected.service],
                ['Budget',  selected.budget ? `₹${selected.budget}` : '—'],
                ['Date',    fmt(selected.created_at)]
              ].map(([l,v]) => (
                <div key={l}>
                  <div style={{ fontSize:'0.72rem', fontWeight:700, color:'#ff6b35', letterSpacing:'0.5px', textTransform:'uppercase', marginBottom:3 }}>{l}</div>
                  <div style={{ fontSize:'0.9rem', color:'#343a40', fontWeight:600 }}>{v}</div>
                </div>
              ))}
              {selected.description && (
                <div>
                  <div style={{ fontSize:'0.72rem', fontWeight:700, color:'#e8603a', letterSpacing:'0.5px', textTransform:'uppercase', marginBottom:6 }}>Description</div>
                  <div style={{ background:'#f8f9fa', borderRadius:10, padding:'14px 16px', fontSize:'0.9rem', color:'#343a40', lineHeight:1.8, border:'1px solid #e9ecef' }}>{selected.description}</div>
                </div>
              )}
              <a href={`mailto:${selected.email}?subject=Quote for ${selected.service}`}
                style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8, padding:'11px', borderRadius:8, background:'#e8603a', color:'white', textDecoration:'none', fontWeight:700, fontSize:'0.88rem', marginTop:4 }}>
                <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                Send Quote
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuotesAdmin;
